import Listado from 'components/public/Listado/Listado';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { titulosListadoEspectaculos } from 'utils/constants';
import { fetchEspectaculos } from 'utils/redux/features/espectaculosSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { formatearFechaParaListado } from 'utils/utilities';
import { EspectaculoBase } from 'utils/models/types';
import Spinner from 'components/public/Spinner/Spinner';

const Espectaculos = () => {
  const navigate = useNavigate();
  const { espectaculos, loadingEspectaculos, errorEspectaculos } = useSelector(
    (state: RootState) => state.espectaculos
  );
  const dispatch = useDispatch<AppDispatch>();
  const error401 = errorEspectaculos?.includes('permisos');

  useEffect(() => {
    dispatch(fetchEspectaculos());
  }, [dispatch]);

  const onAgregar = () => {
    navigate(`/admin/alta-espectaculo`);
  };

  const onEditar = (id: number) => {
    navigate(`/admin/espectaculos/${id}`);
  };

  const espectaculosListado: EspectaculoBase[] = espectaculos.map((e: EspectaculoBase) => {
    const fechaInicio = e.Fechas && formatearFechaParaListado(e.Fechas[0]?.FechaInicio?.toString());
    const fechaFin = e.Fechas && formatearFechaParaListado(e.Fechas[e.Fechas.length - 1]?.FechaInicio?.toString());

    return {
      Id: e.Id,
      AficheUrl: e.AficheUrl,
      BannerUrl: e.BannerUrl,
      BannerDestacado: e.BannerDestacado ? 'Sí' : 'No',
      Nombre: e.Nombre,
      Director: e.Director,
      Precio: `$${e.Precio}`,
      Temporada: fechaInicio !== fechaFin ? `Del ${fechaInicio} al ${fechaFin}` : fechaInicio,
      VisibleEnGrilla: e.VisibleEnGrilla ? 'Sí' : 'No',
      DetallePath: `/espectaculos/${e.Id}`,
    };
  });

  return loadingEspectaculos ? (
    <Spinner />
  ) : errorEspectaculos ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={espectaculosListado}
      headCells={titulosListadoEspectaculos}
      titulo="Gestionar espectáculos"
      onAgregar={onAgregar}
      onEditar={onEditar}
      loading={loadingEspectaculos}
    />
  );
};

export default Espectaculos;
